import { ApplicationType, PlatformDetails } from '../../common/platform/platformTypes';

export const createVersionString = (platformDetails: PlatformDetails): string => {
    switch (platformDetails.appType) {
        case ApplicationType.ipadCapacitor:
        case ApplicationType.iphoneCapacitor:
            return `Milanote iOS app v${platformDetails.appVersion} (${platformDetails.appBuild})`;
        case ApplicationType.androidCapacitor:
        case ApplicationType.androidTabletCapacitor:
            return `Milanote Android app v${platformDetails.appVersion} (${platformDetails.appBuild})`;
        case ApplicationType.pwa:
        case ApplicationType.electronMac:
            return `Milanote desktop app v${platformDetails.appVersion}`;
        default:
            return `Milanote app v${platformDetails.appVersion}`;
    }
};
